import { proxiedFetch } from "../requests";

export function stripSearchFromUrl(url: string) {
	const urlObj = new URL(url);
	url = `${urlObj.protocol}//${urlObj.host}${urlObj.pathname}`;
	return url;
}

export async function getUrlsFromSitemap(sitemapUrl: string) {
	const response = await proxiedFetch(sitemapUrl);

	if (!response.ok) {
		throw new Error(
			`Failed to fetch ${sitemapUrl}. Response status: ${response.status}`
		);
	}

	const parser = new DOMParser();
	const text = await response.text();
	const root = parser.parseFromString(text, "application/xml");

	const locs = root.getElementsByTagName("loc");
	const urls = [];
	for (const loc of locs) {
		if (loc.textContent) {
			// some sitemaps contain url-encoded locs
			urls.push(decodeURIComponent(loc.textContent));
		}
	}

	return urls;
}

export async function getSitemapsFromRobots(robotsUrl: string) {
	const response = await proxiedFetch(robotsUrl);
	if (!response.ok) {
		throw new Error(
			`Failed to fetch ${robotsUrl}. Response status: ${response.status}`
		);
	}
	const text = await response.text();

	const sitemaps: string[] = [];
	const matches = text.matchAll(/Sitemap: (.+)/g);
	for (const [, sitemap] of matches) {
		sitemaps.push(sitemap);
	}

	return sitemaps;
}
